// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOT_LMS = '/lvs';
// const ROOT_INSPECTIONS = 'lvs/inspections/list';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_LMS = {
  root: ROOT_LMS,
  home: path(ROOT_LMS, '/home'),
  admin: path(ROOT_LMS, '/admin'),
  user: {
    list: path(ROOT_LMS, '/admin/user/list'),
    new: path(ROOT_LMS, '/admin/user/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/user/${id}/edit`),
  },
  country: {
    list: path(ROOT_LMS, '/admin/country/list'),
    new: path(ROOT_LMS, '/admin/country/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/country/${id}/edit`),
  },
  company: {
    list: path(ROOT_LMS, '/admin/company/list'),
    new: path(ROOT_LMS, '/admin/company/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/company/${id}/edit`),
  },
  workingdays: {
    list: path(ROOT_LMS, '/admin/working-days/list'),
    new: path(ROOT_LMS, '/admin/working-days/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/working-days/${id}/edit`),
  },
  reviewtypes: {
    list: path(ROOT_LMS, '/admin/review-type/list'),
    new: path(ROOT_LMS, '/admin/review-type/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/review-type/${id}/edit`),
  },
  questions: {
    list: path(ROOT_LMS, '/admin/questions/list'),
    new: path(ROOT_LMS, '/admin/questions/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/questions/${id}/edit`),
  },
  helptextclient: {
    list: path(ROOT_LMS, '/admin/helptextclient/list'),
    new: path(ROOT_LMS, '/admin/helptextclient/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/helptextclient/${id}/edit`),
  },
  helptextreviewer: {
    list: path(ROOT_LMS, '/admin/helptextreviewer/list'),
    new: path(ROOT_LMS, '/admin/helptextreviewer/new'),
    edit: (id: string) => path(ROOT_LMS, `/helptextreviewer/${id}/edit`),
  },
  affiliate: {
    list: path(ROOT_LMS, '/admin/affiliate/list'),
    new: path(ROOT_LMS, '/admin/affiliate/new'),
    edit: (id: string) => path(ROOT_LMS, `/admin/affiliate/${id}/edit`),
  },
  blogcategory: {
    list: path(ROOT_LMS, '/admin/blog-category/list'),
    new: path(ROOT_LMS, '/admin/blog-category/new'),
    edit: (id: string) => path(ROOT_LMS, `/blog-category/${id}/edit`),
  },
  blog: {
    list: path(ROOT_LMS, '/blog/list'),
    new: path(ROOT_LMS, '/blog/new'),
    edit: (id: string) => path(ROOT_LMS, `/blog/${id}/edit`),
    view: (id: string) => path(ROOT_LMS, `/blog/${id}/view`),
  },
  pdf: {
    list: path(ROOT_LMS, '/admin/pdf/list'),
  },
  inspections: {
    list: path(ROOT_LMS, '/inspections/list'),
    new: path(ROOT_LMS, '/inspections/new'),
    edit: (id: string) => path(ROOT_LMS, `/inspections/${id}/edit`),
    view: (id: string) => path(ROOT_LMS, `/inspections/${id}/view`),
  },
  mail: {
    root: path(ROOT_LMS, '/admin/mail'),
  },
  documents: {
    all: path(ROOT_LMS, '/admin/documents/all'),
  },
  personal: {
    profile: path(ROOT_LMS, '/personal/profile'),
  },
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title: string) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
